import simpleRestProvider from 'ra-data-simple-rest';
import { fetchUtils } from 'react-admin';
import { getToken } from './authProvider.js';

const API = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

const httpClient = (url, options = {}) => {
  const headers = options.headers ? new Headers(options.headers) : new Headers({ Accept: 'application/json' });
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(url, { ...options, headers }).catch((err) => {
    // The API replies { error: { message } } — show that instead of a bare "Bad Request".
    const msg = err?.body?.error?.message;
    if (msg) err.message = msg;
    throw err;
  });
};

// Standard simple-rest provider; our backend already emits Content-Range.
const baseProvider = simpleRestProvider(`${API}/admin`, httpClient);

/**
 * Upload a single file to /api/admin/upload and return { url, ... }.
 * Used by ImageUploadInput and TiptapInput to get a hosted URL for inline images.
 */
export async function uploadFile(file) {
  const form = new FormData();
  form.append('file', file);
  const headers = new Headers();
  const token = getToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const res = await fetch(`${API}/admin/upload`, { method: 'POST', headers, body: form });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.error?.message || `Upload failed: ${res.status}`);
  }
  return res.json();
}

export const dataProvider = baseProvider;
